import { render, staticRenderFns } from "./takePicture.vue?vue&type=template&id=ce07ac82&scoped=true"
import script from "./takePicture.vue?vue&type=script&lang=js"
export * from "./takePicture.vue?vue&type=script&lang=js"
import style0 from "./takePicture.vue?vue&type=style&index=0&id=ce07ac82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce07ac82",
  null
  
)

export default component.exports